import React from "react";
import NotFoundComponent from "./NotFound";

const NotFound = () => {
    return <NotFoundComponent />;
};

export default NotFound;
